import React from 'react';
import { HiOutlineLockClosed } from 'react-icons/hi';

interface FixedRecipientFieldProps {
    label: string;
    token: string;
    hint?: string;
}

const FixedRecipientField: React.FC<FixedRecipientFieldProps> = ({ label, token, hint }) => (
    <div>
        <div className="mb-1 text-xs font-medium text-gray-600 dark:text-gray-300">{label}</div>
        <div className="flex flex-wrap items-center gap-1.5 rounded-lg border border-gray-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800 px-2 py-1.5 min-h-[40px]">
            <span className="inline-flex items-center gap-1 rounded-md border border-teal-200 bg-teal-50 px-2 py-0.5 text-xs text-teal-800 dark:border-teal-800 dark:bg-teal-900/40 dark:text-teal-200">
                <HiOutlineLockClosed size={12} className="opacity-70" />
                {token}
            </span>
        </div>
        <p className="mt-1 text-[11px] text-gray-400">{hint ?? 'Preenchido automaticamente com o destinatário de cada envio.'}</p>
    </div>
);

export default FixedRecipientField;
